
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/extra/termsconditions",
      function () {
        return require("private-next-pages/extra/termsconditions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/extra/termsconditions"])
      });
    }
  